module.exports = __webpack_public_path__ + "img/3.f7141b10.png";